module.exports = __webpack_public_path__ + "static/media/404_mobile.3b221474c82ccc20ba5d855714d1f4c6.svg";